__webpack_require__.p = "/dm-tabs/referrals-hub/";